// In its own file to avoid circular dependencies
export type ResponseWithMethod = Response & { method?: string };
